import { createAction } from "redux-act";

export const getFilteredReportList = createAction('Get Filtered Report List')
export const getFilteredReportListSuccessful = createAction('Get Filtered Report List Success')
export const getFilteredReportListFailure = createAction('Get Filtered Report List Fail')
